export class Director {
  public id: string;
  public user:any;
  public Nivel: string;
  public username: string;
  public NomApe: string;
  constructor() {}
}
